(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.topRow = this.querySelector('.header');
      this.menuRow = this.querySelector('.header__menu-wrapper');
      this.icons = this.querySelector('.header__icons');
      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.predictiveSearch = this.querySelector('predictive-search');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.latestScrollTop = this.currentScrollTop;
      this.preventReveal = false;
      this.scrollFrame = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.onMediaChangeHandler = this.onMediaChange.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);
      this.desktopMedia.addEventListener('change', this.onMediaChangeHandler);

      this.createObserver();

      requestAnimationFrame(() => {
        this.measureDesktopHeader();
        this.updateDesktopProgress(this.currentScrollTop);
      });
    }

    measureDesktopHeader() {
      if (!this.header || !this.topRow || !this.menuRow || !this.desktopMedia.matches) return;

      const topRowRect = this.topRow.getBoundingClientRect();
      const menuRowRect = this.menuRow.getBoundingClientRect();

      this.expandedRowHeight = Math.max(topRowRect.height, 1);
      this.compactRowHeight = Math.max(menuRowRect.height, 58);
      this.collapseDistance = this.expandedRowHeight;

      /*
        Die Icons werden nur einmal vermessen. Beim Scrollen wird anschließend
        ausschließlich ein transform-Wert gesetzt; die Geometrie bleibt stabil.
      */
      if (this.icons) {
        const headerRect = this.header.getBoundingClientRect();
        const iconsRect = this.icons.getBoundingClientRect();
        const iconCenterInsideHeader =
          iconsRect.top - headerRect.top + iconsRect.height / 2;
        const compactTargetCenter =
          this.expandedRowHeight + this.compactRowHeight / 2;

        this.iconsTravel = compactTargetCenter - iconCenterInsideHeader;
      } else {
        this.iconsTravel = 0;
      }

      this.header.style.setProperty(
        '--kf-expanded-row-height',
        `${this.expandedRowHeight.toFixed(2)}px`
      );
      this.setHeaderHeight();
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.desktopMedia.removeEventListener('change', this.onMediaChangeHandler);

      if (this.scrollFrame) {
        cancelAnimationFrame(this.scrollFrame);
      }

      window.clearTimeout(this.resizeTimer);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        if (this.desktopMedia.matches) {
          this.measureDesktopHeader();
          this.updateDesktopProgress(
            window.pageYOffset || document.documentElement.scrollTop
          );
        }
      }, 100);
    }

    onMediaChange(event) {
      if (event.matches) {
        requestAnimationFrame(() => {
          this.measureDesktopHeader();
          this.updateDesktopProgress(
            window.pageYOffset || document.documentElement.scrollTop
          );
        });
      } else {
        this.resetDesktopStyles();
      }
    }

    onScroll() {
      this.latestScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        if (this.desktopMedia.matches) {
          this.updateDesktopProgress(this.latestScrollTop);
        } else {
          this.updateMobileHeader(this.latestScrollTop);
        }

        this.scrollFrame = null;
      });
    }

    updateDesktopProgress(scrollTop) {
      if (!this.header || !this.collapseDistance) return;

      /*
        Der Fortschritt basiert nur auf der Scrollposition und einer einmalig
        gemessenen Zeilenhöhe. Es wird während des Scrollens keine Bildgröße,
        Breite oder Headerhöhe erneut abgefragt.
      */
      const rawProgress = Math.min(
        Math.max(scrollTop / this.collapseDistance, 0),
        1
      );

      const easedProgress =
        rawProgress * rawProgress * (3 - 2 * rawProgress);

      const largeFadeProgress = this.smoothStep(0.04, 0.78, rawProgress);
      const smallFadeProgress = this.smoothStep(0.38, 0.96, rawProgress);

      const largeOpacity = 1 - largeFadeProgress;
      const largeScale = this.reducedMotion.matches
        ? 1
        : 1 - 0.18 * easedProgress;

      const smallOpacity = smallFadeProgress;
      const smallScale = this.reducedMotion.matches
        ? 1
        : 0.82 + 0.18 * easedProgress;

      const iconsY = this.reducedMotion.matches
        ? 0
        : this.iconsTravel * easedProgress;

      this.header.style.setProperty(
        '--kf-large-logo-opacity',
        largeOpacity.toFixed(3)
      );
      this.header.style.setProperty(
        '--kf-large-logo-scale',
        largeScale.toFixed(3)
      );
      this.header.style.setProperty(
        '--kf-small-logo-opacity',
        smallOpacity.toFixed(3)
      );
      this.header.style.setProperty(
        '--kf-small-logo-scale',
        smallScale.toFixed(3)
      );
      this.header.style.setProperty(
        '--kf-icons-y',
        `${iconsY.toFixed(2)}px`
      );
      this.header.style.setProperty(
        '--kf-header-shadow-alpha',
        (0.16 * easedProgress).toFixed(3)
      );
      const compact = rawProgress >= 0.985;

      this.header.classList.toggle('scrolled-past-header', compact);
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      this.currentScrollTop = scrollTop;
    }

    smoothStep(edgeStart, edgeEnd, value) {
      const progress = Math.min(
        Math.max((value - edgeStart) / (edgeEnd - edgeStart), 0),
        1
      );

      return progress * progress * (3 - 2 * progress);
    }

    resetDesktopStyles() {
      if (!this.header) return;

      [
        '--kf-expanded-row-height',
        '--kf-large-logo-opacity',
        '--kf-large-logo-scale',
        '--kf-small-logo-opacity',
        '--kf-small-logo-scale',
        '--kf-icons-y',
        '--kf-header-shadow-alpha'
      ].forEach((property) => this.header.style.removeProperty(property));

      this.header.classList.remove('scrolled-past-header');
    }

    updateMobileHeader(scrollTop) {
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
